import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
  Typography
} from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

const formatSeconds = (totalSeconds) => {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  return minutes > 0
    ? `${minutes}:${seconds.toString().padStart(2, '0')}`
    : `${seconds}s`;
};

export const SessionTimeoutDialog = ({
  open,
  secondsRemaining,
  onStaySignedIn,
  onSignOut
}) => {
  if (!open) return null;

  return (
    <Dialog
      open={open}
      onClose={onStaySignedIn}
      aria-labelledby="session-timeout-dialog-title"
      aria-describedby="session-timeout-dialog-description"
      slotProps={{
        paper: {
          sx: { borderRadius: 2, p: 1, maxWidth: 440 }
        }
      }}
    >
      <DialogTitle id="session-timeout-dialog-title" sx={{ display: 'flex', alignItems: 'center', gap: 1.5, pb: 1 }}>
        <AccessTimeIcon color="warning" />
        <Typography variant="h6" component="span" fontWeight="bold">
          Session Expiring Soon
        </Typography>
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="session-timeout-dialog-description" sx={{ color: 'text.primary', mb: 1 }}>
          You have been inactive. For your privacy and security on shared or public devices, your session will automatically end in:
        </DialogContentText>
        <Box
          sx={{
            textAlign: 'center',
            py: 1.5,
            my: 1,
            bgcolor: 'warning.light',
            color: 'warning.contrastText',
            borderRadius: 1.5,
            fontWeight: 'bold',
            fontSize: '1.25rem'
          }}
        >
          {formatSeconds(secondsRemaining)}
        </Box>
        <Typography variant="caption" color="text.secondary">
          Click &quot;Stay Signed In&quot; to keep working, or &quot;Sign Out Now&quot; to end your session.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2, justifyContent: 'space-between' }}>
        <Button
          onClick={() => onSignOut('manual')}
          color="inherit"
          sx={{ textTransform: 'none' }}
        >
          Sign Out Now
        </Button>
        <Button
          onClick={onStaySignedIn}
          variant="contained"
          color="primary"
          autoFocus
          sx={{ fontWeight: 'bold' }}
        >
          Stay Signed In
        </Button>
      </DialogActions>
    </Dialog>
  );
};
